<template>
  <div class="flex p-20">
    <div class="flex flex-col w-1/3">
      <div class="text-16 font-bold">Properties</div>
      <div class="text-13 text-gray-400">
        These properties will be automatically calculated and displayed to the customer for each part.
      </div>
    </div>

    <div>
      <div class="flex w-full justify-between">
        <div class="flex-1 gap-8">
          <div class="text-16 font-semibold text-center mb-8" v-text="'Part Properties'" />
          <div class="flex flex-col gap-12">
            <SparkCheckbox
              v-for="(property, key) in partProperties"
              :key="key"
              v-model="property.value"
              :name="key"
              @update:modelValue="handlePropertyChange(key, 'part')"
            >
              <div class="text-13">{{ property.label }}</div>
            </SparkCheckbox>
          </div>
        </div>
        <div class="flex-1 gap-12 pl-200">
          <div class="text-16 text-center font-semibold mb-8" v-text="'Process Chain Properties'" />
          <div class="flex flex-col gap-4">
            <SparkCheckbox
              v-for="(property, key) in processChainProperties"
              :key="key"
              v-model="property.value"
              :name="key"
              @update:modelValue="handlePropertyChange(key, 'process')"
            >
              <div class="text-13">{{ property.label }}</div>
            </SparkCheckbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SparkCheckbox from '@/components/SparkComponents/SparkCheckbox.vue';

export default {
  name: 'CustomPrpInfo',

  components: { SparkCheckbox },

  data() {
    return {
      partProperties: {},
      processChainProperties: {},
      isLoaded: false,
      isUpdating: false,
    };
  },

  computed: {
    ...mapState('application', ['axiosInstance']),
  },

  async created() {
    await this.fetchPrpSettingsProperties();
  },

  methods: {
    async fetchPrpSettingsProperties() {
      try {
        const response = await this.axiosInstance.get('api/v1/prp-properties/');
        const properties = response.data;
        this.partProperties = properties.partProperties;
        this.processChainProperties = properties.processChainProperties;
        
        // Mark as loaded after initial data is set
        this.$nextTick(() => {
          this.isLoaded = true;
        });
      } catch (error) {
        console.error('Failed to fetch PRP settings properties:', error);
      }
    },

    async updateProperties(formData) {
      try {
        await this.axiosInstance.put('api/v1/prp-properties/', formData);
      } catch (error) {
        console.error('Failed to update PRP settings properties:', error);
      }
    },

    handlePropertyChange(propertyKey, type) {
      // Only update if component has finished loading and not currently in an update
      if (this.isLoaded && !this.isUpdating) {
        // Set a flag to prevent multiple simultaneous updates
        this.isUpdating = true;
        
        // Use setTimeout to ensure the update happens after the current call stack
        setTimeout(() => {
          this.updateProperties({
            partProperties: this.partProperties,
            processChainProperties: this.processChainProperties,
          }).finally(() => {
            this.isUpdating = false;
          });
        }, 0);
      }
    },
  },
};
</script>
